// extracted by mini-css-extract-plugin
export default {"section":"EFv3CEayk8ufad_IsQl_","header":"P9d2jJUT2Vur4v37iE5Y","knowledgeTiles":"KbSFp_pslJwXQWrxOX6a","headerTitle":"W60wbmRkglhM_SIPft7x","loaderRoot":"GuWOSkUhlxwI_dddY5IS"};